import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import TemplateDetail from '../emails/TemplateDetail';
import cookie from 'react-cookies';
import { getBuilderURL } from '../../../common/utils/builder-url-util';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import CustomLoader from '../../common/CustomLoader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';

export class SnippetTemplateTab extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = { snippetsBySearch: [], searchKey: '', showLoader: false, expandedSections: ['SNIPPET'] };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.projectId !== this.props.projectId) {
      this.props.actions.loadSnippets({
        projectId: nextProps.projectId,
        version: nextProps.version,
      });
    }
    return true;
  }

  componentDidMount() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      actions.loadSnippets({ projectId, version });
    }
  }

  handleRefresh() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      this.setState({ showLoader: true });
      actions.loadSnippets({ projectId, version }).then(() => this.setState({ showLoader: false }));
    }
  }

  filterSnippetsBySearch = (event) => {
    const { value } = event.target;
    const { snippets } = this.props.home;
    const snippetsBySearch = findBySearchString('name', value, snippets);
    let expandedSections = [];
    if (value.length > 0) {
      if (snippetsBySearch.some((item) => item.snippetType === 'SNIPPET'))
        expandedSections.push('SNIPPET');
      if (snippetsBySearch.some((item) => item.snippetType === 'MODAL'))
        expandedSections.push('MODAL');
      if (snippetsBySearch.some((item) => item.snippetType === 'CUSTOM_SEGMENT'))
        expandedSections.push('CUSTOM_SEGMENT');
      if (snippetsBySearch.some((item) => item.snippetType === 'SUB_PAGE'))
        expandedSections.push('SUB_PAGE');
      if (snippetsBySearch.some((item) => item.snippetType === 'PDF_TEMPLATE'))
        expandedSections.push('PDF_TEMPLATE');
      if (snippetsBySearch.some((item) => item.snippetType === 'PAGE_LAYOUT'))
        expandedSections.push('PAGE_LAYOUT');
    } else {
      expandedSections = ['SNIPPET'];
    }

    this.setState({ snippetsBySearch, searchKey: value, expandedSections });
  };

  showSnippetList = (snippets, snippetType) => {
    const { version, projectId } = this.props;
    const snippetList = snippets.filter((template) => template.snippetType === snippetType);
    return snippetList.map((template) => (
      <TemplateDetail
        key={template.uuid}
        name={template.name}
        uuid={template.uuid}
        template={template}
        uri="snippets"
        projectId={projectId}
        redirectUrl={getBuilderURL()}
        snippetType={template.snippetType}
        version={version}
      />
    ));
  };

  renderAccordionContent = (item) => {
    const { showLoader } = this.state;
    const { snippets } = this.props.home;

    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-devices-c"></div>
          {this.state.searchKey.length > 0 ? (
            this.showSnippetList(this.state.snippetsBySearch, item.key).length > 0 ? (
              this.showSnippetList(this.state.snippetsBySearch, item.key)
            ) : (
              <p>No {item.title} matching your search.</p>
            )
          ) : snippets && snippets.length > 0 ? (
            showLoader ? (
              <CustomLoader loading={showLoader} />
            ) : this.showSnippetList(snippets, item.key).length > 0 ? (
              this.showSnippetList(snippets, item.key)
            ) : (
              <p>No {item.title}.</p>
            )
          ) : (
            <p>No {item.title}.</p>
          )}
        </div>
      </Fragment>
    );
  };

  renderAccordion = () => {
    const accordionItems = [
      { title: 'Snippet', key: 'SNIPPET' },
      { title: 'Modal', key: 'MODAL' },
      { title: 'Custom Segment', key: 'CUSTOM_SEGMENT' },
      { title: 'Sub Page', key: 'SUB_PAGE' },
      { title: 'PDF Template', key: 'PDF_TEMPLATE' },
      { title: 'Page Layout', key: 'PAGE_LAYOUT' },
    ];

    return accordionItems.map((item) => (
      <AccordionItem key={item.key} uuid={item.key}>
        <AccordionItemState>
          {({ expanded }) => (
            <>
              <AccordionItemHeading className="gjs-block-category">
                <AccordionItemButton className="gjs-title">
                  <span
                    className={
                      expanded
                        ? 'gjs-caret-icon fa fa-caret-down'
                        : 'gjs-caret-icon fa fa-caret-right'
                    }
                  ></span>
                  &nbsp;
                  {item.title}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel style={{ padding: '0px' }}>
                {this.renderAccordionContent(item)}
              </AccordionItemPanel>
            </>
          )}
        </AccordionItemState>
      </AccordionItem>
    ));
  };

  render() {
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const { expandedSections } = this.state;
    const { version, projectId } = this.props;
    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Snippet" className="padding-left-20">
              Snippet
            </span>
            <span
              title="Reload Snippets"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Snippets"
                data-place="bottom"
                data-effect="solid"
                onClick={() => this.handleRefresh()}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span title="Snippet" className="">
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip="Create New Template"
                data-place="bottom"
                data-effect="solid"
                href={`${getBuilderURL()}editor/${version}/v/${projectId}/loader?token=${token}`}
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add Snippet
              </a>
            </span>
          </div>
          <div className="gjs-devices-c"></div>
        </div>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-devices-c"></div>
          <div className="form-outline" style={{ padding: '10px' }}>
            <input
              type="search"
              className="custom-bootstrap-form-control custom-bootstrap-form-control-sm"
              placeholder="&#xf55c; Eg: Header"
              style={{ fontFamily: 'Arial, Webconnect' }}
              onChange={this.filterSnippetsBySearch}
            />
          </div>
          <Accordion
            key={expandedSections.join(',')}
            allowZeroExpanded
            preExpanded={expandedSections}
          >
            {this.renderAccordion()}
          </Accordion>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SnippetTemplateTab);
